function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.5 134.4h198.6V163H42.5zM42.5 177h198.6v28.6H42.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241 70.8V56.7h-49.7v14.1H92.4V56.7H42.6v14.1H0v177.3h283.5V70.8H241zm14.1 148.9H28.3V99.1h226.8v120.6z"
}))));